// src/utils/rollbarPerson.js
// Контекст события Rollbar — кто и в какой компании: пользователь и компания
// из стора. Раньше жил только внутри setErrorMixin.setError; FT-173 (часть I)
// вынес его сюда, чтобы и reportRentToOwnFailure (модуль «Аренда с выкупом»
// не зовёт setError — тот пишет строку сервера в this.error) слал события с
// тем же контекстом. Поведение setError не меняется.
export function configureRollbarPerson(vm) {
  if (!vm || !vm.$rollbar || typeof vm.$rollbar.configure !== "function") return;
  const user = vm.$store ? vm.$store.getters.getCurrentUser : null;
  const companyWrap = vm.$store ? vm.$store.getters.getCompany : null;
  vm.$rollbar.configure({
    payload: {
      person: {
        id: user ? user.id : null,
        username: user && user.name ? user.name : null,
        email: user && user.email ? user.email : null,
      },
      custom: {
        company: companyWrap && companyWrap.company && companyWrap.company.name ? companyWrap.company.name : null,
      },
    },
  });
}
